import { render, staticRenderFns } from "./orgTeam.vue?vue&type=template&id=6d0e2578&scoped=true&"
import script from "./orgTeam.vue?vue&type=script&lang=js&"
export * from "./orgTeam.vue?vue&type=script&lang=js&"
import style0 from "./orgTeam.vue?vue&type=style&index=0&id=6d0e2578&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0e2578",
  null
  
)

export default component.exports